/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stop': {
    width: 16,
    height: 16,
    viewBox: '0 0 131.31 175.08',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M120.37 0a10.91 10.91 0 00-10.94 10.94v153.17a10.94 10.94 0 1021.88 0V10.94A10.91 10.91 0 00120.37 0zM10.94 0A10.91 10.91 0 000 10.94v153.17a10.94 10.94 0 1021.88 0V10.94A10.91 10.91 0 0010.94 0z"/></g></g>'
  }
})
